import createElementChangeListener from "../../elementChangeListener";

export default function tabsHandler(_context, container) {
    const activeHeaderClass = "js--active";
    const activeBodyClass = "active";

    const tabs = [];
    const tabsBodyChildren = [];

    function removeHeaderClass(tab) {
        tab.classList.remove(activeHeaderClass);
    }

    function removeBodyClass(el) {
        el.classList.remove(activeBodyClass);
    }

    function onClick(event) {
        const { currentTarget } = event;
        const { target } = currentTarget.dataset;
        tabs.forEach(removeHeaderClass);
        tabsBodyChildren.forEach(removeBodyClass);

        currentTarget.classList.add(activeHeaderClass);
        const tabContent = container.querySelector(target);
        tabContent && tabContent.classList.add(activeBodyClass);
    }

    function onNewTab(element) {
        tabs.push(element);
        element.addEventListener("click", onClick);
    }

    function onNewTabBody(element) {
        tabsBodyChildren.push(element);
    }

    createElementChangeListener(".tabs__head > .tabs__tab", onNewTab, false, container);
    createElementChangeListener(".tabs__body > .tabs__tab-content", onNewTabBody, false, container);
}
